import React, { useState } from "react";
import { Button, Popover, DatePicker, Divider } from "antd";
import { FilterFilled } from "@ant-design/icons"

import { cn } from "../../lib/utils";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const DateRangeFilter = ({ className, onChange, onClear, children }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const content = (
        <div className="space-y-4">
            <RangePicker
                onChange={(dates) => {
                    setStartDate(dates[0]); setEndDate(dates[1])
                }}
                value={[startDate, endDate]}
            />
            {children}
            <Divider />
            <div className="flex justify-end gap-1">
                <Button
                    type="link"
                    onClick={() => {
                        setStartDate(null);
                        setEndDate(null);
                        onClear();
                    }}
                >
                    Clear
                </Button>
                <Button
                    type="primary"
                    onClick={() => {
                        onChange({ startDate: dayjs(startDate).toDate(), endDate: dayjs(endDate).toDate() });
                    }}
                >
                    Apply
                </Button>
            </div>
        </div>
    )

    return (
        <div className={cn(className)}>
            <Popover trigger="click" title="Filter" content={content} placement="bottom">
                <Button type="text" size="small"><FilterFilled className="text-gray-400" /></Button>
            </Popover>
        </div>
    )
}

export default DateRangeFilter;
